import React from "react"
import { useTranslation } from "react-i18next"
import {
  withFormik,
  FormikProps,
  FormikErrors,
  Form,
  Field,
  FieldProps,
} from "formik"
import { Grid } from "@mui/material"

import i18n from "config/i18n"
import Input from "components/ui/Input"
import { Submit } from "components/Subscription/Modal/Create/elements"
import { SubscriptionPhoneConfirmationValues } from "types"

interface FormProps {
  initialValues: {
    subscription_id: string
    user_auth_request_id: string
    verification_code: string
  }
  onSubmit: (values: SubscriptionPhoneConfirmationValues) => void
}

type Props = FormikProps<SubscriptionPhoneConfirmationValues> & FormProps

const SubscriptionMobilePaymentConfirmationForm = ({
  errors,
  isSubmitting,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Form>
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <Field name="verification_code">
            {({ field }: FieldProps) => (
              <Input
                fullWidth
                label={t("features.subscription.form.verification_code")}
                helperText={errors.verification_code}
                disabled={isSubmitting}
                {...field}
              />
            )}
          </Field>
        </Grid>
        <Submit type="submit" disabled={isSubmitting}>
          {t("features.subscription.form.submit")}
        </Submit>
      </Grid>
    </Form>
  )
}

const SubscriptionMobilePaymentConfirmationFormWithFormik = withFormik<
  FormProps,
  SubscriptionPhoneConfirmationValues
>({
  enableReinitialize: true,
  mapPropsToValues: ({ initialValues }) => initialValues,
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
  validate: (values: SubscriptionPhoneConfirmationValues) => {
    const errors: FormikErrors<SubscriptionPhoneConfirmationValues> = {}

    const { verification_code } = values

    if (!verification_code) {
      errors.verification_code = i18n.t("validation.field.required", {
        field: i18n.t("features.subscription.form.verification_code"),
      })
    }

    return errors
  },
})(SubscriptionMobilePaymentConfirmationForm)

export default SubscriptionMobilePaymentConfirmationFormWithFormik
